import { Component, OnInit } from '@angular/core';
import { ManagePropertyComponent } from './manage-property/manage-property.component';
import { ManagePaddocksComponent } from './manage-paddocks/manage-paddocks.component';
import { CommonModule } from '@angular/common';
import { UserDetailsComponent } from './user-details/user-details.component';
import { ToolsComponent } from './tools/tools.component';
import { NavComponent } from '../nav/nav.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: true,
    imports:[
      CommonModule,
      ManagePropertyComponent,
      ManagePaddocksComponent,
      UserDetailsComponent,
      ToolsComponent,
      NavComponent,
      FooterComponent
    ]
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
